import { t } from 'i18next'
import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'
import { BackButton, PageContentDropdown, SubHeader } from '../../components'
import useWorkspaceDetails from '../../hooks/useWorkspaceDetails'
import { routePaths } from '../RootPage'
import {
  WorkspaceTab,
  workspacePanelTypes,
  workspaceTabs,
} from './WorkspaceDetailsPage'
import DocumentSetDetailsPageLayout from './components/DocumentSetDetailsPageLayout'
import DocumentSetDetailsPageTabs from './components/DocumentSetDetailsPageTabs'
import DocumentStatusSwitch from './components/DocumentStatusSwitch'
import { WorkspaceSmartFunctionPanel } from './panels'
import { WorkspaceOverviewInfoConformityCheckDocumentPanel } from './panels'

const ListPanelLayout = styled.div`
  height: calc(100vh - 124px);
  border-radius: 16px 16px 0px 0px;
`

const FloatLeftContainer = styled.div`
  display: flex;
  margin-left: auto;
  order: 2;
  gap: 8px;
  align-items: center;
  margin-left: auto;
  white-space: nowrap;
`

const WorkspaceConformityDocumentDetailsPage = () => {
  const { workspaceId, documentId, tab } = useParams()
  const navigate = useNavigate()
  const [fetchDone, setFetchDone] = useState(false)

  const { refreshWorkspaceDetails } = useWorkspaceDetails({
    workspaceId,
    preventFetch: true,
  })

  const [selectedWorkspaceTab, setSelectedWorkspaceTab] = useState(
    tab as WorkspaceTab
  )

  useEffect(() => {
    if (!fetchDone) {
      refreshWorkspaceDetails()
      setFetchDone(true)
    }
  }, [fetchDone, refreshWorkspaceDetails])

  const handleChange = (value: string) => {
    setSelectedWorkspaceTab(value as WorkspaceTab)
    navigate(
      `${routePaths.WORKSPACE_DETAILS}/${workspaceId}/${workspacePanelTypes.DOCUMENTS}/${value}/${documentId}`
    )
  }

  const handleWorkspaceDetailsPanelExport = () => {}

  const renderPanel = useCallback(() => {
    switch (selectedWorkspaceTab) {
      case workspaceTabs.INFO:
        return <WorkspaceOverviewInfoConformityCheckDocumentPanel />
      case workspaceTabs.SMART_FUNCTION:
        return <WorkspaceSmartFunctionPanel />
      default:
        return <WorkspaceOverviewInfoConformityCheckDocumentPanel />
    }
  }, [selectedWorkspaceTab])

  return (
    <DocumentSetDetailsPageLayout selectedWorkspaceTab={selectedWorkspaceTab}>
      <SubHeader>
        <BackButton
          type="default"
          tooltipMessage={t('workspaceDetailsPage.backToDocuments')}
          url={`${routePaths.WORKSPACE_DETAILS}/${workspaceId}/${workspacePanelTypes.DOCUMENTS}/${workspaceTabs.INFO}`}
        />
        <DocumentSetDetailsPageTabs
          selectedWorkspaceTab={selectedWorkspaceTab}
          handleChange={handleChange}
        />

        <FloatLeftContainer>
          <DocumentStatusSwitch />
          <PageContentDropdown onExport={handleWorkspaceDetailsPanelExport} />
        </FloatLeftContainer>
      </SubHeader>
      <ListPanelLayout>{renderPanel()}</ListPanelLayout>
    </DocumentSetDetailsPageLayout>
  )
}

export default WorkspaceConformityDocumentDetailsPage
